export default __webpack_public_path__ + "static/media/fail.f8f9982e.wav";